/** Selective clinical + material imagery used across the experience. */
export const imagery = {
  enamel:
    'https://cdn.magicpatterns.com/patterns/generated-images/90e4a7fc-1173-46c2-928d-b123b09b50ab.jpg',
  layers:
    'https://cdn.magicpatterns.com/patterns/generated-images/f7a343a7-a11e-48f4-82e0-364a36b859d5.jpg',
  anterior:
    'https://cdn.magicpatterns.com/patterns/generated-images/f2f65605-4ee7-4e0b-a8d2-f0ecd09a048b.jpg',
  flow:
    'https://cdn.magicpatterns.com/patterns/generated-images/ea63ed12-929e-450b-a1c5-fb89bd0dbdc8.jpg',
  posterior:
    'https://cdn.magicpatterns.com/patterns/generated-images/3ef7c3a2-d97b-40e7-98e5-9b8b2f71e913.jpg'
}
